<form *ngIf='formGroup' [formGroup]='formGroup' class='display-contents'>
  <!--  [ngClass]="{'valid': formGroup.valid}"-->
  <tr class="retention-and-deletion-tr">
    <td class="td-vertical-align ps-2">
      {{ value?.categoryName }}
    </td>
    <td class="td-vertical-align">
      <div class="table-col-2">
        <div class='form-check d-flex align-items-center'>
          <input [value]='false'
                 class='form-check-input'
                 formControlName='retentionPeriodOther'
                 type='radio'>
          <div class='select-period'>
            <input formControlName='retentionPeriod'
                   min='0'
                   type='number'>
            <select class='form-select form-select-unit'
                    formControlName='retentionPeriodUnit'>
              <option *ngFor='let option of unit' [value]='option.uuid'>
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        <div class='form-check'>
          <input [value]='true'
                 class='form-check-input'
                 formControlName='retentionPeriodOther'
                 id='{{id}}__retentionPeriodOtherFalse'
                 type='radio'>
          <label class='form-check-label'
                 for='{{id}}__retentionPeriodOtherFalse'>
            {{ header.retentionPeriodOther }}
          </label>
        </div>
      </div>
    </td>
    <td class="td-vertical-align">
      <div class="table-col-3">
        <div (click)="openTextArea('retentionPeriodReason', header.retentionPeriodReason)"
             [ngStyle]="{
                'height': '61px',
                '-webkit-line-clamp': 3}"
             class='drad-textarea'>
          {{ formGroup.controls['retentionPeriodReason']?.value }}
        </div>
      </div>
    </td>
    <td class="td-vertical-align">
      <div class="table-col-4">
        <div class='form-check checkbox-v0-form'>
          <input class='form-check-input'
                 formControlName='pseudonymization'
                 id='{{id}}_pseudonymization' type='checkbox'>
          <label class='form-check-label' for='{{id}}_pseudonymization'>
            {{ header.pseudonymization }}
          </label>
        </div>

        <div class='form-check checkbox-v0-form'>
          <input class='form-check-input'
                 formControlName='anonymization'
                 id='{{id}}_anonymization' type='checkbox'>
          <label class='form-check-label' for='{{id}}_anonymization'>
            {{ header.anonymization }}
          </label>
        </div>

        <div class='form-check checkbox-v0-form'>
          <input class='form-check-input'
                 formControlName='deletion'
                 id='{{id}}_deletion' type='checkbox'>
          <label class='form-check-label' for='{{id}}_deletion'>
            {{ header.deletion }}
          </label>
        </div>
      </div>
    </td>
    <td class="td-vertical-align">
      <div class="table-col-5">
        <div (click)="openTextArea('note', header.note)"
             [ngStyle]="{
              'height': '61px',
              '-webkit-line-clamp': 3}"
             class='drad-textarea'>
          {{ formGroup.controls['note']?.value }}
        </div>
      </div>
    </td>
  </tr>
</form>
